export const MUTATION_TYPES = {
  SET_ACADEMICYEARS: 'SetAcademicYears',
  SET_MEETINGTYPES: 'SetMeetingTypes',
  SET_RESULTS_FILTERED: 'SetResults',
  SET_CURRENT_FILTERS: 'setCurrentFilters',
};
//actions Think is need to do this? (Only if is calling )
export const ACTION_TYPES = {
  GET_FILTERS: 'GetFilters',
  GET_RESULTS_FILTERED: 'GetResultsFiltered',
};
